import { get } from "../httpmethods";
import { URL_API } from "../config";

export const ClassificationAPI = {
    getClassifications: async () => {
        return await get(`${URL_API}/classifications`);
    }
}
